import { useSelector } from 'react-redux';
import { selectCurrentUserRoles } from '@features/auth/slice';

export const SUPER_ADMIN_ROLE = 'super-admin';

export function useIsSuperAdmin(): boolean {
  const roles = useSelector(selectCurrentUserRoles);
  return roles.some((role) => role.name?.toLowerCase() === SUPER_ADMIN_ROLE);
}
